import React from "react";
import { ReactComponent as Arrow } from "../images/arrow.svg"
export function ScrollButton(){
    
    let toTop = ()=>{
        window.scrollTo(0,0);
    }
    return(
        <button id="scrollbutton" onClick={toTop}>
            <Arrow/>
        </button>
    );
}